<template>
    <div class="Sensing-view">
        <div class="header-box">
            <div class="txt">环境监测</div>
            <div class="header-r-box" v-if="cgqList.length">
                <div class="sel-box">
                    <el-select v-model="cgqAct" placeholder="请选择" @change="cgqChange">
                        <el-option v-for="item in cgqList" :key="item.subDeviceNum" :label="item.subDeviceName"
                            :value="item.subDeviceNum">
                        </el-option>
                    </el-select>
                </div>
                <div class="icon" :class="{ 'icon-lx': !playIdObj.online }" @click="alarmConfiguration"></div>
            </div>
        </div>
        <template v-if="cgqList.length">
            <!-- 上面具体数据 -->
            <div class="right-top">
                <div class="rt-relative">
                    <div class="relative-div" :class="{ 'relative-div-noleft': codeInfoLisst.length == 1 }">
                        <div v-if="codeIsWarn" class="flex flex_a_c flex_ju_c top-tipdiv">
                            <img class="icon_warn" src="@/assets/image/home/icon_warn.png" alt="" />
                            <span class="font_14 c_six">设备已离线</span>
                        </div>
                        <div v-else class="font_14 c_six top-tipdiv">
                            采集时间：{{ codeInfos.dateTime || "--" }}
                            <div class="shuaxin_div" @click="refreshData">
                                <i class="el-icon-refresh" :class="{ i_rotate: iconRotate }"></i>
                                <span>刷新</span>
                            </div>
                        </div>
                        <img class="img_bg" src="@/assets/image/production/img_bg.png" alt="" />
                    </div>
                </div>
                <div class="flex flex_ju_sb rt-absolute">
                    <!-- 左边的 -->
                    <production-left :data="codeLeftList"
                        v-if="codeInfoLisst.length > 1 || codeInfoLisst.length == 0"></production-left>
                    <div class="rights"></div>
                    <production-right :data="codeRightList" :ent-length="codeInfoLisst.length"
                        :class="{ 'right-noleft': codeInfoLisst.length == 1 }"></production-right>
                    <!-- 右边的 -->
                </div>
                <div v-if="codeTotalPage > 1" class="flex flex_a_c code-pages">
                    <span class="cursor el-icon-caret-left code-icon" :class="{ 'code-icon-hui': codePage == 1 }"
                        @click="codePageChange('-')"></span>
                    <div class="c_six">
                        <span style="color: #42b5b2">{{ codePage }}</span>/{{ codeTotalPage }}
                    </div>
                    <span class="cursor el-icon-caret-right code-icon"
                        :class="{ 'code-icon-hui': codePage == codeTotalPage }" @click="codePageChange('+')"></span>
                </div>
            </div>
            <!-- 下面折线图 -->
            <div class="right-chart">
                <el-form :model="queryParam" ref="warnform" :inline="true"
                    class="flex flex_ju_sb warnform-inline rb-form">
                    <div class="form-inputs">
                        <el-form-item label="">
                            <el-select placeholder="请选择" v-model="queryParam.listparam">
                                <el-option v-for="item in itemsSelect" :key="item.dataItemCode"
                                    :label="item.dataItemName" :value="item.dataItemCode"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="" class="form-picker">
                            <div class="picker-divs picker-divs-more">
                                <el-date-picker v-model="queryParam.startTime" size="small" type="datetime"
                                    placeholder="选择日期" popper-class="pick-poper" class="picker-div"
                                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" prefix-icon=" "
                                    clear-icon="el-icon-date" :clearable="false" :picker-options="pickerOptions0"
                                    :editable="false">
                                </el-date-picker>
                                <i class="pick-icon el-icon-date"></i>
                                <i class="pick-icon-yuan el-icon-time"></i>
                            </div>

                            <span class="pick-word">至</span>
                            <div class="picker-divs picker-divs-more">
                                <el-date-picker v-model="queryParam.endTime" size="small" type="datetime"
                                    placeholder="选择日期" popper-class="pick-poper" class="picker-div"
                                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" prefix-icon=" "
                                    clear-icon="el-icon-date" :clearable="false" :picker-options="pickerOptions1"
                                    :editable="false">
                                </el-date-picker>
                                <i class="pick-icon el-icon-date"></i>
                                <i class="pick-icon-yuan el-icon-time"></i>
                            </div>
                        </el-form-item>
                    </div>

                    <el-form-item class="form-btns">
                        <el-button type="primary" @click="searchClick">查询</el-button>
                    </el-form-item>
                </el-form>
                <!-- 图表 -->
                <div class="chart-lines" ref="chartLine" v-show="isLine"></div>
                <div class="table-empty chart-lines flex flex_col flex_a_c flex_ju_c" v-show="!isLine">
                    <img class="table-noimg" src="@/assets/image/home/ZWT.png" alt="" />
                    <div class="table-emptyword">暂无数据</div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="table-empty flex flex_col flex_ju_c flex_a_c trees-box">
                <img class="table-noimg" src="@/assets/image/product/zwsj2.png" alt="" />
                <div class="table-emptyword">未配置环境监测设备</div>
            </div>
        </template>

        <!-- 信息提示 -->
        <Msg ref="myMsg"></Msg>
        <!-- 告警配置抽屉 -->
        <AlarmConfiguration ref="AlarmConfiguration"></AlarmConfiguration>
    </div>
</template>

<script>
import ProductionLeft from "../components/productionLeft.vue";
import ProductionRight from "../components/productionRight.vue";
import Msg from "@/components/msg.vue"; //信息提示组件
import AlarmConfiguration from "../components/AlarmConfiguration.vue";
import {
    todayTime,
    GetPreMonthDay,
    GetNextMonthDay,
    getFormatDate,
} from "@/times/moment";
export default {
    components: { ProductionLeft, ProductionRight, Msg, AlarmConfiguration },
    props: ['cgqList', "playIdObj"],
    data() {
        return {
            cgqAct: "",
            codeSelect: [], // 传感器下拉选,用作采集项的下拉选获取
            codeInfos: {
                dateTime: "--",
            }, // 传感器详细数据
            iconRotate: false, // 控制刷新图标
            iconRotateTimer: null, //刷新点击定时器
            codeInfoLisst: [
                // {
                //   itemCode: "EYHT",
                //   itemName: "二氧化碳",
                //   itemUnitCode: "ppm",
                //   itemValue: "--",
                // },
            ],// 左边的数据
            codeLeftList: [
                // {
                //   itemCode: "EYHT",
                //   itemName: "二氧化碳",
                //   itemUnitCode: "ppm",
                //   itemValue: "--",
                // },
            ],
            codePage: 1, // 实时数据当前页面
            codeTotalPage: 1, // 实时数据总页码
            // 右边的数据
            codeRightList: [
                // {
                //   itemCode: "TRSD",
                //   itemName: "土壤湿度",
                //   itemUnitCode: "%",
                //   itemValue: "--",
                // },
            ],
            codeIsWarn: false, // 传感器是否是异常状态
            queryParam: {
                listparam: "",
                startTime: "",
                endTime: "",
            },

            itemsSelect: [], // 采集项下拉选
            isLine: false, // 是否显示折线图
            pickerOptions0: {
                disabledDate: (time) => {
                    if (this.queryParam.endTime) {
                        if (this.queryParam.endTime != "") {
                            let num = new Date(this.queryParam.endTime).getTime();
                            return time.getTime() > num;
                        } else {
                        }
                    } else {
                        return false;
                    }
                },
            },
            pickerOptions1: {
                disabledDate: (time) => {
                    let num = new Date().getTime();
                    if (time.getTime() > num) {
                        return true;
                    } else {
                        let startNum =
                            new Date(this.queryParam.startTime).getTime() - 43200000;
                        if (time.getTime() < startNum) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                },
            },
        }
    },
    methods: {
        // 传感器切换
        cgqChange() {
            let cgqActObj = this.cgqList.filter((item) => {
                return item.subDeviceNum == this.cgqAct
            })
            console.log('cgqActObj',cgqActObj);
            
            if (cgqActObj.length) {
                cgqActObj[0].itemList.sort((a, b) => {
                    return a.sort - b.sort;
                });
                this.itemsSelect = cgqActObj[0].itemList;
                this.queryParam.listparam = this.itemsSelect[0].dataItemCode;
                this.deviceSensorData();
                this.deviceSensorLinedata();
            }

        },
        // 打开告警配置
        alarmConfiguration() {
            if (!this.cgqList.length) {
                this.$refs.myMsg.msgShow("暂无设备", 1.5);
                return;
            }
            this.$refs.AlarmConfiguration.deviceNum = this.playIdObj.deviceNum;
            let arr = [
                {
                    id: "all",
                    label: "全部",
                },
            ];
            this.cgqList.forEach((item) => {
                arr.push({
                    id: item.subDeviceNum,
                    label: item.subDeviceName,
                });
            });
            this.$refs.AlarmConfiguration.optionList = arr;
            this.$refs.AlarmConfiguration.cgqList = this.cgqList;
            // this.$refs.AlarmConfiguration.csList = this.cgqList[0].itemList;
            this.$refs.AlarmConfiguration.stAlarmConfList();
            this.$refs.AlarmConfiguration.drawer = true;
        },
        // 刷新实时数据
        refreshData() {
            if (this.iconRotateTimer) {
                return;
            }
            this.iconRotateTimer = null;
            this.iconRotate = true;
            this.deviceSensorData();
            this.iconRotateTimer = setTimeout(() => {
                this.iconRotate = false;
                clearTimeout(this.iconRotateTimer);
                this.iconRotateTimer = null;
            }, 2000);
        },
        // 传感器实事数据
        deviceSensorData() {
            this.$http
                .postAction(
                    this.$api.deviceSensorData +
                    "?deviceId=" +
                    this.playIdObj.id +
                    "&subDeviceId=" +
                    this.cgqAct
                )
                .then((res) => {
                    if (res.data.arrivalTime) {
                        this.codeIsWarn = false;
                        this.codeInfos.dateTime = res.data.arrivalTime;
                    } else {
                        this.codeIsWarn = true;
                        this.codeInfos.dateTime = "";
                    }
                    if (res.data.propList.length) {
                        this.codeIsWarn = false;
                        let envItems = [];
                        res.data.propList.forEach((item) => {
                            if(item.dataItemCode == "FX") {
                                item.dataItemValue = this.getFxtype(item.dataItemValue);
                                item.dataItemUnit = ''
                            }
                            envItems.push({
                                itemCode: item.dataItemCode,
                                itemName: item.dataItemName,
                                itemUnitCode: item.dataItemUnit,
                                itemValue: item.dataItemValue,
                            });
                        });
                        this.codeInfoLisst = envItems;
                        // 总页码赋值
                        this.codeTotalPage = Math.ceil(envItems.length / 8);
                        this.codePage = 1;
                        // 大于8开始分页
                        this.makeInfoItems(envItems);
                    } else {
                        this.codeIsWarn = true;
                        // 设备异常赋值下拉选数据
                        let envItems = [];
                        this.itemsSelect.forEach((item) => {
                            envItems.push({
                                itemCode: item.dataItemCode,
                                itemName: item.dataItemName,
                                itemUnitCode: item.unitName,
                                itemValue: "--",
                            });
                        });
                        this.codeInfoLisst = envItems;
                        // 总页码赋值
                        this.codeTotalPage = Math.ceil(envItems.length / 8);
                        this.codePage = 1;
                        // 大于8开始分页
                        this.makeInfoItems(envItems);
                    }
                });
        },
        getFxtype(value) {
            let typename = ''
            if (value >= 348.76 || value <= 11.25) {
                typename = '北风'
            } else if (value >= 11.26 && value <= 33.75) {
                typename = '北东北风'
            } else if (value >= 33.76 && value <= 56.25) {
                typename = '东北风'
            } else if (value >= 56.26 && value <= 78.75) {
                typename = '东东北风'
            } else if (value >= 78.76 && value <= 101.25) {
                typename = '东风'
            } else if (value >= 101.26 && value <= 123.75) {
                typename = '东东南风'
            } else if (value >= 123.76 && value <= 146.25) {
                typename = '东南风'
            } else if (value >= 146.26 && value <= 168.75) {
                typename = '南东南风'
            } else if (value >= 168.76 && value <= 191.25) {
                typename = '南风'
            } else if (value >= 191.26 && value <= 213.75) {
                typename = '南西南风'
            } else if (value >= 213.76 && value <= 236.25) {
                typename = '西南风'
            } else if (value >= 236.26 && value <= 258.75) {
                typename = '西西南风'
            } else if (value >= 258.76 && value <= 281.25) {
                typename = '西风'
            } else if (value >= 281.26 && value <= 303.75) {
                typename = '西西北风'
            } else if (value >= 303.76 && value <= 326.25) {
                typename = '西北风'
            } else if (value >= 326.26 && value <= 348.75) {
                typename = '北西北风'
            }
            return typename
        },
        makeInfoItems(envItems) {
            // 大于8开始分页
            if (envItems.length >= 8) {
                this.codeLeftList = envItems.filter((item, index) => {
                    return index < 4;
                });
                this.codeRightList = envItems.filter((item, index) => {
                    return index >= 4 && index < 8;
                });
            } else {
                if (envItems.length == 1) {
                    this.codeLeftList = [];
                    this.codeRightList = envItems;
                } else {
                    let splitNum = Math.floor(
                        (envItems.length % 2) + envItems.length / 2
                    );
                    this.codeLeftList = envItems.filter((item, index) => {
                        return index < splitNum;
                    });
                    this.codeRightList = envItems.filter((item, index) => {
                        return index >= splitNum && index < envItems.length;
                    });
                }
            }
        },
        // 折线图数据
        deviceSensorLinedata() {
            let params = {
                deviceId: this.playIdObj.id,
                startTime: this.queryParam.startTime,
                endTime: this.queryParam.endTime,
                subDeviceId: this.cgqAct,
                dataItems: [this.queryParam.listparam],
            };
            this.$http
                .postAction(this.$api.deviceSensorLinedata, params)
                .then((res) => {
                    if (res.data.xList.length) {
                        this.isLine = true;
                        let xData = res.data.xList;
                        let yData = [];
                        let yName = "";
                        let yUnit = "";
                        let code = "";
                        res.data.yList.forEach((item, index) => {
                            if (index == 0) {
                                code = Object.keys(item);
                            }
                            yData.push(item[code]);
                        });
                        let arr = this.itemsSelect.filter((item) => {
                            if (item.dataItemCode == code) {
                                return item;
                            }
                        });
                        yName = arr[0].dataItemName;
                        yUnit = arr[0].unitName;
                        this.$nextTick(() => {
                            this.lineChart(xData, yData, yName, yUnit);
                        });
                    } else {
                        this.isLine = false;
                    }
                });
        },
        // x轴时间过长换行展示
        xlabelBreak(text) {
            // console.log(text.length) // 19
            // console.log(text); // 2022-04-22 17:17:48
            return text.replace(/\s/, "\n");
        },
        // 折线图绘制
        lineChart(xData, yData, yName, yUnit) {
            // xData = [1, 2, 3];
            // yData = [1, 2, 3];
            // yName = "温度";
            // yUnit = "℃";
            const _this = this;
            let myChart = this.$echarts.init(this.$refs.chartLine);
            let maxY = Math.max(...yData);
            let symbolSize = 60;
            let symbolFont = 12;
            if (maxY.length <= 2) {
                symbolSize = 40;
                symbolFont = 16;
            } else if (maxY.length > 2 && maxY.length <= 3) {
                symbolSize = 50;
                symbolFont = 14;
            } else if (maxY.length > 3 && maxY.length < 4) {
                symbolSize = 60;
                symbolFont = 12;
            } else {
                symbolSize = 65;
                symbolFont = 12;
            }
            let option = {
                tooltip: {
                    show: true,
                    trigger: "axis",
                    backgroundColor: "#fff",
                    padding: [14, 17],
                    axisPointer: {
                        type: "line",
                        lineStyle: {
                            color: "#DADADA",
                            type: "solid",
                            width: 2,
                        },
                    },
                    extraCssText:
                        "box-shadow: 0px 0px 12px 0px rgba(76, 216, 179, 0.33);text-align:left;font-size:14px;color:#3F3F3F;letter-spacing: 1px;",
                    formatter: function (param) {
                        let infos = "";
                        infos += `<div style="text-align:left;">${yName}：<span style="color:#2DAEA9">${param[0].value}${yUnit}</span></div><div style="margin-top:12px">${param[0].name}</div`;
                        return infos;
                    },
                },
                color: "#2DAEA9",
                grid: {
                    left: "8%",
                    bottom: "16%",
                    top: "16%",
                    right: "6%",
                },
                xAxis: {
                    type: "category",
                    data: xData,
                    // 刻度线
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#EDEDED",
                            width: 2,
                        },
                    },
                    axisLabel: {
                        color: "#6B6B6B",
                        fontSize: 14,
                        // lineHeight: 30,
                        formatter: (par) => {
                            // console.log(par)
                            return this.xlabelBreak(par);
                        },
                    },
                    boundaryGap: false,
                },
                yAxis: {
                    type: "value",
                    name: "（" + yUnit + "）",
                    nameTextStyle: {
                        color: "#6B6B6B",
                        fontSize: 14,
                        align: "right",
                    },
                    axisLabel: {
                        color: "#6B6B6B",
                        fontSize: 14,
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#EDEDED",
                            width: 2,
                        },
                    },
                },
                series: [
                    {
                        type: "line",
                        smooth: true,
                        showSymbol: false,
                        symbolSize: 10,
                        itemStyle: {
                            borderColor: "#2DAEA9",
                            borderWidth: 8,
                        },
                        areaStyle: {
                            color: "rgba(45, 174, 169, 0.26)",
                        },
                        lineStyle: {
                            width: 4,
                        },
                        markPoint: {
                            symbolSize: symbolSize,
                            label: {
                                color: "#fff",
                                fontSize: symbolFont,
                            },
                            data: [
                                {
                                    type: "max",
                                    name: "最大值",
                                    itemStyle: {
                                        color: "#FF648C",
                                    },
                                },
                                {
                                    type: "min",
                                    name: "最小值",
                                    itemStyle: {
                                        color: "#3EA2EF",
                                    },
                                },
                            ],
                        },
                        markLine: {
                            data: [
                                {
                                    type: "average",
                                    name: "平均值",
                                    lineStyle: {
                                        type: "solid",
                                        color: "#FFA800",
                                    },
                                    label: {
                                        position: "middle",
                                        formatter: "平均值:{c}",
                                        color: "#FFA800",
                                        distance: 10,
                                        fontSize: 16,
                                    },
                                    symbol: "none",
                                },
                            ],
                        },
                        data: yData,
                    },
                ],
            };
            myChart.clear();
            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },
        // 打开告警配置
        alarmConfiguration() {
            if (!this.cgqList.length) {
                this.$refs.myMsg.msgShow("暂无设备", 1.5);
                return;
            }
            this.$refs.AlarmConfiguration.deviceNum = this.playIdObj.deviceNum;
            let arr = [
                {
                    id: "all",
                    label: "全部",
                },
            ];
            this.cgqList.forEach((item) => {
                arr.push({
                    id: item.subDeviceNum,
                    label: item.subDeviceName,
                });
            });
            this.$refs.AlarmConfiguration.optionList = arr;
            this.$refs.AlarmConfiguration.cgqList = this.cgqList;
            // this.$refs.AlarmConfiguration.csList = this.cgqList[0].itemList;
            this.$refs.AlarmConfiguration.stAlarmConfList();
            this.$refs.AlarmConfiguration.drawer = true;
        },
        // 查询点击
        searchClick() {
            this.deviceSensorLinedata();
        },
        // 初始化
        init() {
            this.$set(this.queryParam, "startTime", `${todayTime()} 00:00:00`);
            this.$set(this.queryParam, "endTime", `${todayTime()} 23:59:59`);
            if (this.cgqList.length) {
                this.cgqAct = this.cgqList[0].subDeviceNum;
                
                this.cgqList[0].itemList.sort((a, b) => {
                    return a.sort - b.sort;
                });
                this.itemsSelect = this.cgqList[0].itemList;
                this.queryParam.listparam = this.itemsSelect[0].dataItemCode;
                this.deviceSensorData();
                this.deviceSensorLinedata();
            } else {
                this.cgqAct = "";
                this.codeLeftList = [];
                this.codeRightList = []
                this.codePage = 1;
                this.codeTotalPage = 1;
                this.codeIsWarn = false;
                this.itemsSelect = [];
                this.isLine = false;
            }

        }
    },
}
</script>

<style lang="scss" scoped>
.Sensing-view {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.header-box {
    height: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    border-bottom: 1px solid #f1f1f1;
    padding: 0 0.3rem;

    .txt {
        font-size: 0.225rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #454545;
    }

    .sel-box {
        width: 2.75rem;
        height: 0.45rem;
    }

    .header-r-box {
        display: flex;
        align-items: center;

        .icon-lx {
            filter: grayscale(100%);
        }
    }

    .icon {
        margin-left: 0.5rem;
        cursor: pointer;
        width: 0.45rem;
        height: 0.45rem;
        background: url("~@/assets/image/product/shezhi2.png") no-repeat;
    }

    .icon-no {
        background: url("~@/assets/image/product/shezhi3.png") no-repeat;
        pointer-events: none;
        cursor: default;
    }
}

.right-top {
    position: relative;
    margin-top: 0.325rem;

    .relative-div {
        position: relative;
        width: 6.56rem;
        left: 50%;
        transform: translateX(-50%);

        .top-tipdiv {
            position: relative;
            z-index: 10;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 0.3125rem;

            .shuaxin_div {
                cursor: pointer;
                width: 0.9rem;
                height: 0.3125rem;
                border: 1px solid #32ad9b;
                border-radius: 0.05rem;
                margin-left: 0.1875rem;
                box-sizing: border-box;
                display: flex;
                justify-content: center;
                align-items: center;

                i {
                    color: #2daea9;
                    font-size: 18px;
                }

                .i_rotate {
                    animation: rotate 2s infinite;
                }

                span {
                    color: #2daea9;
                    margin-left: 0.1rem;
                    font-size: 0.175rem;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #32ad9b;
                }

                @keyframes rotate {
                    0% {
                        transform: rotate(0);
                    }

                    100% {
                        transform: rotate(360deg);
                    }
                }
            }

            .shuaxin {
                cursor: pointer;
                margin-left: 0.1875rem;
                width: 0.9125rem;
                height: 0.3125rem;
            }
        }
    }

    .relative-div-noleft {
        left: 0.6rem;
        transform: translateX(0);
    }

    .img_bg {
        width: 5.7375rem;
        height: 2.4rem;
        margin-top: 0.725rem;
    }

    .icon_warn {
        width: 0.25rem;
        margin-right: 0.06rem;
        margin-top: -0.04rem;
    }

    .rt-absolute {
        position: absolute;
        width: 100%;
        height: 92%;
        top: 0.5rem;
        left: 0;
        padding: 0 0.25rem 0 0.38rem;
        z-index: 8;
    }

    .right-noleft {
        padding-right: 1.25rem;
    }

    .code-pages {
        position: absolute;
        z-index: 10;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        font-size: 0.17rem;

        .code-icon {
            color: #afafaf;
        }

        .code-icon-hui {
            color: #d8d8d8;
        }
    }
}

.table-empty {
    flex: 1;
}
</style>